import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UpdateBankState, updateBankFeatureKey } from '../reducers/update-bank.reducer';

export const getUpdateBankState = createFeatureSelector<UpdateBankState>(updateBankFeatureKey);
export const getUpdateBankLoading = createSelector(getUpdateBankState, state => state.loading);
export const getUpdateBankResponse = createSelector(getUpdateBankState, state => state.response);
export const getUpdateBankError = createSelector(getUpdateBankState, state => state.error);